import React from 'react'
import { Grid, TextField, FormControl, Select, MenuItem, FormHelperText } from '@mui/material';


function SFForm({ fields, data, handleFormChange, height }) {
    return (
        <div style={{ height: height ? height : '350px' }}>
            <Grid container spacing={3}>
                {fields?.map((field, index) => {
                    return (
                        <Grid item xs={12} sm={6} key={index}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                                {field.name}
                                {/* {field.isRequired ? "(*)" : ""} */}
                            </label>
                            {field.type === "text" || field.type === "number" ?
                                <TextField
                                    id={field.id}
                                    name={field.name + (field.isRequired ? "*" : "")}
                                    type={field.type}
                                    disabled={field.disabled}
                                    value={data[field.id] || ''}
                                    onChange={(event) => {
                                        handleFormChange(field.id, event.target.value)
                                    }}
                                    required={field.isRequired}
                                    error={field.isRequired && !data[field.id]}
                                    helperText={field.isRequired && !data[field.id] ? "This field is required." : ""}
                                    placeholder={field.placeholder ? field.placeholder : field.name}
                                    fullWidth
                                    variant="standard"
                                />
                                : null}

                            {field.type === 'select' ?
                                <FormControl
                                    fullWidth
                                    variant="standard"
                                    required={field.isRequired}
                                    error={field.isRequired && !data[field.id]}
                                >
                                    <Select
                                        id={field.id}
                                        value={data[field.id] || field.defaultValue || ''}
                                        displayEmpty
                                        onChange={(event) => {
                                            handleFormChange(field.id, event.target.value, field.items)
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            {field.placeholder || field.name}
                                        </MenuItem>
                                        {field.items?.map((item, idx) => (
                                            <MenuItem key={item.value || item || idx} value={item.value || item}>
                                                {item.label || item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {field.isRequired && !data[field.id] && (
                                        <FormHelperText>This field is required.</FormHelperText>
                                    )}
                                </FormControl>
                                : null}
                        </Grid>
                    )
                })}
            </Grid>
        </div>
    )
}

export default SFForm